
import React from 'react';
import { Flame, Star, Medal, Trophy, Sparkle, Calendar, CheckCircle } from 'lucide-react';

interface StatCardsProps {
  streak: number;
  points: number;
  medal: {
    name: string;
    emoji: string;
  };
  currentDay?: number | null;
  lessonsCompleted?: number | null;
}

const StatCards: React.FC<StatCardsProps> = ({ 
  streak, 
  points, 
  medal, 
  currentDay = 1, 
  lessonsCompleted = 0 
}) => {
  return (
    <div className="grid grid-cols-3 gap-4 mb-2">
      <div className="flex flex-col items-center">
        <div className="w-14 h-14 rounded-full bg-hormony-coral/10 flex items-center justify-center mb-2 relative">
          <Flame size={24} className="text-hormony-coral" />
          {streak >= 3 && (
            <Sparkle className="absolute -top-1 -right-1 text-hormony-coral" size={16} />
          )}
        </div>
        <div className="text-lg font-semibold text-hormony-charcoal">{streak}</div>
        <div className="text-xs text-hormony-charcoal/70">Day Streak</div>
      </div>
      
      <div className="flex flex-col items-center">
        <div className="w-14 h-14 rounded-full bg-hormony-coral/10 flex items-center justify-center mb-2 relative">
          <Star size={24} className="text-hormony-coral" />
          {points >= 100 && (
            <Sparkle className="absolute -top-1 -right-1 text-hormony-coral" size={16} />
          )}
        </div>
        <div className="text-lg font-semibold text-hormony-charcoal">{points}</div>
        <div className="text-xs text-hormony-charcoal/70">Total Points</div>
      </div>
      
      <div className="flex flex-col items-center">
        <div className="w-14 h-14 rounded-full bg-hormony-coral/10 flex items-center justify-center mb-2 relative">
          {medal.name === "Gold" || medal.name === "Platinum" ? (
            <Trophy size={24} className="text-hormony-coral" />
          ) : (
            <Medal size={24} className="text-hormony-coral" />
          )}
          {(medal.name === "Gold" || medal.name === "Platinum") && (
            <Sparkle className="absolute -top-1 -right-1 text-hormony-coral" size={16} />
          )}
        </div>
        <div className="text-sm font-semibold text-hormony-charcoal">
          {medal.name || 'No Medal Yet'}
        </div>
        <div className="text-xs text-hormony-charcoal/70">
          {medal.emoji || '-'}
        </div>
      </div>

      {/* Only show the current day and lessons completed row if both values are not null */}
      {currentDay !== null && lessonsCompleted !== null && (
        <div className="col-span-3 grid grid-cols-2 gap-4 mt-1">
          <div className="flex items-center p-2 rounded-lg bg-hormony-beige/10">
            <div className="w-10 h-10 rounded-full bg-hormony-coral/10 flex items-center justify-center mr-3">
              <Calendar size={20} className="text-hormony-coral" />
            </div>
            <div>
              <div className="text-md font-semibold text-hormony-charcoal">Day {currentDay}</div>
              <div className="text-xs text-hormony-charcoal/70">Current Day</div>
            </div>
          </div>
          
          <div className="flex items-center p-2 rounded-lg bg-hormony-beige/10">
            <div className="w-10 h-10 rounded-full bg-hormony-coral/10 flex items-center justify-center mr-3">
              <CheckCircle size={20} className="text-hormony-coral" />
            </div>
            <div>
              <div className="text-md font-semibold text-hormony-charcoal">{lessonsCompleted}</div>
              <div className="text-xs text-hormony-charcoal/70">Lessons Done</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatCards;
